import { Component } from "@angular/core";
import { BugListComponent } from "../../components/bug-list/bug-list.component";

@Component({
	selector: "intervention-tracker",
	standalone: true,
	imports: [BugListComponent],
	templateUrl: "./intervention-tracker.component.html",
	styleUrl: "./intervention-tracker.component.css",
})
export class InterventionTrackerComponent {}
